import axios from 'axios';
import serverMessage from '../server-message';

export default function create({ name, code, description, moduleIds }) {
  return new Promise((resolve, reject) => {
    axios
      .post(`/account/system-admin/api/v1/bundle`, {
        name,
        code,
        description,
        moduleIds,
      })
      .then((response) => resolve(response.data))
      .catch((error) => reject(serverMessage(error)));
  });
}
